module.exports = __webpack_public_path__ + "static/logo_mask_1024x305-6a9c44c2174d5d9a24b88703ca742f0e.png";